var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-dialog',{attrs:{"title":_vm.title,"width":"80%","append-to-body":""},on:{"close":_vm.handleClose},model:{value:(_vm.localVisible),callback:function ($$v) {_vm.localVisible=$$v},expression:"localVisible"}},[_c('img',{staticStyle:{"width":"100%"},attrs:{"src":_vm.imageUrl,"alt":"预览图片"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }